import { IProdutoExportExcel } from "../interfaces/IExport";

const parseNameColumn = (column: string) => {
  return column
}

const getUrlImagem = (codProduto: string) => {
  let url_empresa;
  switch (localStorage.empresa) {
    case '1':
      url_empresa = 'images';
      break;
    case '2':
      url_empresa = 'images_lyor';
      break;
    case '3':
      url_empresa = 'images_house36';
      break;
  }
  return `https://gruporojemac.dnsalias.com/candide/${url_empresa}/${codProduto}.jpg`;
};

const formatDate = (input: string) => {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const getCategorias = () => {
  try {
    const storageCategorias = localStorage.getItem('categorias')
    const categorias: {
      codCat: string 
      desCat: string
    }[] = storageCategorias
        ? JSON.parse(storageCategorias)
        : [];

    return categorias
  } catch (error) {
    console.error('Erro ao parsear categorias do localStorage:', error);
    return [];
  }
}

const filterColumnsUfOnline = (produto: IProdutoExportExcel, sigUfs?: string) => {
  if (!sigUfs) return produto

  const filterFields = Object.keys(produto)
    .filter(column => column?.startsWith('MVA') || column?.startsWith('ST'))

  for (let key in filterFields) {
    if (filterFields[key].slice(-2) === sigUfs) {
      delete filterFields[key]
    }
  }

  filterFields.forEach(key => {
    if (produto.hasOwnProperty(key)) {
      //@ts-ignore
      delete produto[key]
    }
  })

  return produto
}

const filterColumnsUfLocal = (produto: any, sigUfs?: string) => {
  if (!sigUfs) return produto

  const filterFields = Object.keys(produto)
    .filter(column => column?.startsWith('MVA') || column?.startsWith('ST'))

  for (let key in filterFields) {
    if (filterFields[key].slice(-2) === sigUfs) {
      delete filterFields[key]
    }
  }

  filterFields.forEach(key => {
    if (produto.hasOwnProperty(key)) {
      //@ts-ignore
      delete produto[key]
    }
  })

  return produto
}

const getMateriais = () => {
  try {
    const storageMateriais = localStorage.getItem('materiais');
    const materiais: {
      valkey: string | null,
      keynam: string | null
    }[] = storageMateriais
        ? JSON.parse(storageMateriais)
        : [];
    return materiais
  } catch (error) {
    console.error('Erro ao parsear materiais do localStorage:', error);
    return [];
  }
};

export {
  formatDate,
  getUrlImagem,
  getCategorias,
  getMateriais,
  parseNameColumn,
  filterColumnsUfOnline,
  filterColumnsUfLocal,
}